import React from 'react';
import { createEmptyHeader } from 'framework/table/createEmptyHeader';
import { ISettlementProposal } from 'gen/ApiClient';
import { SettlementProposalStatusChip } from '../../../settlementProposals/sps/SettlementProposalStatusChip';

export const PrependColumn = createEmptyHeader<ISettlementProposal>('prepend', t => <SettlementProposalStatusChip data={t} />);
